import clientRendering from './clientRendering';

export default () => clientRendering && window.innerWidth < 768;
